<template>
  <div class="app-feature-tile__container">
    <app-feature-icon :src="icon" class="app-feature-tile__icon" />
    <div class="app-feature-tile__title">{{ title }}</div>
  </div>
</template>

<script>
import AppFeatureIcon from './AppFeatureIcon'

export default {
  name: 'AppFeatureTile',
  components: {
    AppFeatureIcon
  },
  props: {
    icon: {
      type: String
    },
    title: {
      type: String
    }
  }
}
</script>

<style scoped>
.app-feature-tile__container {
  display: flex;
  flex-direction: column;
  font-family: "Avenir-Medium";
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  width: 12.9rem;
  height: 15.63rem;
  color: #332924;
  letter-spacing: 0;
}

.app-feature-tile__icon {
  height: 8rem;
  width: 8rem;
}

.app-feature-tile__title {
  font-family: "Avenir-Medium";
  font-size: 1.5rem;
  width: 100%;
  color: #332924;
  text-align: center;
  margin: 0;
}
@media only screen and (min-width: 550px) {
  /* Every leading tile will have trailing margin. */
  .app-feature-tile__container:nth-of-type(3n-2) {
    margin-right: 4rem;
  }

  /* Every third tile will have leading margin. */
  .app-feature-tile__container:nth-of-type(3n) {
    margin-left: 4rem;
  }
}
</style>
